import React from 'react';
import {withStyles} from "@mui/styles";
import {Styles} from "../../../config/design/styles";
import {connect, getStore} from "trim-redux";
import LogoIgm from '../../../files/img/logo/logo.png'
import LogoOldIgm from '../../../files/img/logo/logo-old.png'
import {Link} from "react-router-dom";

const Logo = (props) => {

    return (
        <div style={props.parentStyle}>
            <Link to={'/'}>
                <img
                    style={props.style}
                    className={props.classes.LayoutLogo}
                    src={props.old_logo ?LogoOldIgm : LogoIgm}
                    alt={getStore('app_name')}
                />
            </Link>
        </div>
    );
};
const mstp = state => ({
    navCollapsed: state.navCollapsed,
    logo: state.logo,
    user: state.user,
    isAuth: state.isAuth,
});
export default withStyles(Styles)(connect(mstp)(Logo));
